import {useRouter} from "next/router";
import localized from "../../locale/locales";
import SectionTiles from "./SectionTiles";
import imageCardio1Desktop from "../../public/img/cardio1_desktop.jpg";
import imageCardio2Desktop from "../../public/img/cardio2_desktop.jpg";
import imageCardio3Desktop from "../../public/img/cardio3_desktop.jpg";
import imageCardio3Mobile from "../../public/img/cardio3_mobile.jpg";
import imageCardio1Mobile from "../../public/img/cardio1_mobile.jpg";
import imageCardio2Mobile from "../../public/img/cardio2_mobile.jpg";
import Typo from "../Typo";


export default function SectionCardioZone() {
    const {locale} = useRouter();
    const lang = localized[locale].gym.cardioZone;

    return (
        <div className="w-full overflow-hidden md:overflow-visible -mb-12 md:mb-0">
            <SectionTiles direction="right" title={lang.title} images={{
                desktop: [
                    imageCardio1Desktop,
                    imageCardio2Desktop,
                    imageCardio3Desktop,
                ],
                mobile: [
                    imageCardio3Mobile,
                    imageCardio1Mobile,
                    imageCardio2Mobile,
                ],
            }}>
                {lang.body.map((item, key) => <Typo key={`Cardio: ${key}`}>{item}</Typo>)}
            </SectionTiles>
        </div>
    )
}